import {useCallback, useRef, useMemo} from 'react'
import {getTickerDisplay} from 'utils/ticker'
import {useMappedState} from 'redux-react-hook'
import {SITE_TITLE} from 'constants'
import {formatNumber} from 'utils/format'
import useSymbolInfo from 'hooks/useSymbolInfo'

function useTicker (symbol) {
  const mapState = useCallback(
    state => ({
      ticker: state?.entities?.tickers?.[symbol] || {},
      adl: state?.entities?.adl
    }),
    [symbol]
  )
  const {ticker, adl} = useMappedState(mapState)
  const {symbolInfo} = useSymbolInfo()
  const {pricePrecision} = symbolInfo
  const lastPrice = ticker?.lastPrice // use aggTrades[0].price instead
  const lastPriceRef = useRef(lastPrice)
  const lastPriceSign = useMemo(() => {
    let sign = 0
    if (lastPriceRef.current - lastPrice > 0) {
      sign = -1
    } else if (lastPriceRef.current - lastPrice < 0) {
      sign = 1
    }
    if (lastPrice && lastPriceRef.current !== lastPrice) {
      document.title = `${formatNumber(lastPrice, pricePrecision)} | ${symbol} | ${SITE_TITLE}`
    }
    lastPriceRef.current = lastPrice
    return sign
  }, [lastPrice, pricePrecision, symbol])

  const display = getTickerDisplay({...ticker, adl, lastPriceSign}, symbol)
  return display
}

export default useTicker
